import { GroupCellRenderer } from 'components/GroupCellRenderer';
import { Grid } from 'components/shared/Grid';
import { ContentType } from 'constants/types';
import React from 'react';
import { connect } from 'react-redux';
import { groupRowsWithUnmappedAccountsSelector } from 'selectors/groupRows';
import { periodColumnsSelector } from 'selectors/periods';

class GroupsFilterableGridBase extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
    };

    this.autoGroupColumnDef = {
      headerName: '',
      sort: 'asc',
      comparator: (nodeA, nodeB) => {
        let nA = parseInt(nodeA.split('-')[0], 10);
        let nB = parseInt(nodeB.split('-')[0], 10);
        return Math.sign(nA - nB);
      },
      cellRendererParams: {
        suppressCount: true,
        suppressDoubleClickExpand: true,
        innerRenderer: 'groupCellRenderer',
      },
    };

    this.frameworkComponents = { groupCellRenderer: GroupCellRenderer };

    this.cols = [
      {
        field: 'number',
        colId: 'number',
        headerName: 'Number',
        width: 90,
      },
      {
        field: 'code',
        colId: 'code',
        headerName: 'Code',
        width: 90,
      },
      ...props.periodColumns,
    ];
  }

  handleSearchChange = ({ target }) =>
    this.setState({ searchText: target.value });

  handleCellDoubleClicked = ({ data }) => {
    const id = parseInt(data.id, 10);

    if (!data.group || this.props.canSelectGroup) {
      this.props.onSelect(
        data.group ? ContentType.group : ContentType.account,
        id,
        data.description
      );
    }
  };

  getContextMenuItems = ({ node }) => {
    if (!node) {
      return ['expandAll', 'contractAll'];
    }

    const { canSelectGroup } = this.props;
    const isGroup = node.data.group;
    const disabled = isGroup && !canSelectGroup;
    let name = `Select ${isGroup ? 'Group' : 'Account'}`;

    if (disabled) {
      name += ' (Groups cannot be selected for AJE)';
    }

    return [
      {
        name,
        disabled,
        action: () =>
          this.props.onSelect(
            isGroup ? ContentType.group : ContentType.account,
            node.data.id,
            node.data.description
          ),
      },
      'separator',
      'expandAll',
      'contractAll',
    ];
  };

  render() {
    return (
      <div className="groups-filterable-grid">
        <input
          type="text"
          autoComplete="off"
          placeholder="Search"
          onChange={this.handleSearchChange}
        />
        <Grid
          columnDefs={this.cols}
          rowData={this.props.rows}
          animateRows={true}
          treeData={true}
          getDataPath={(data) => data.groupPath}
          getRowNodeId={(data) => `${data.group ? 'G' : 'A'}-${data.id}`}
          groupDefaultExpanded={0}
          autoGroupColumnDef={this.autoGroupColumnDef}
          frameworkComponents={this.frameworkComponents}
          getContextMenuItems={this.getContextMenuItems}
          onCellDoubleClicked={this.handleCellDoubleClicked}
          quickFilterText={this.state.searchText}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rows: groupRowsWithUnmappedAccountsSelector(state),
    periodColumns: periodColumnsSelector(state, {
      isGroups: true,
      useGroupsPrecision: true,
      hasMostImportantCols: true,
      hasMostImportantPeriods: true,
    }),
  };
}

export const GroupsFilterableGrid = connect(mapStateToProps)(
  GroupsFilterableGridBase
);
